module.exports = __webpack_public_path__ + "img/resources.b11a1c00.png";